import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import ReactTable from 'react-table-v6'
import { map, sortBy, uniqBy, includes, isNil } from 'lodash'

const VcenterAssetReportVcenters = ({ vcenters }) => {
  const sites = sortBy(uniqBy(map(vcenters, 'site'), 'name'), 'name')
  const columns = [
    {
      Header: 'Name',
      accessor: 'name',
      Cell: (data) => isNil(data.original.href) ? data.value : <a target='_blank' href={data.original.href}>{data.value}</a>
    },
    {
      Header: 'Site',
      accessor: 'site.name',
      Filter: ({ filter, onChange }) => (
        <select onChange={event => onChange(event.target.value)} style={{ width: "100%" }} value={filter ? filter.value : "all"}>
          <option value="all">Show All</option>
          {map(sites, site => (
            <option value={site.name}>{site.name}</option>
          ))}
        </select>
      )
    }
  ]

  return (
    <ReactTable
      data={vcenters}
      columns={columns}
      minRows={0}
      filterable
      defaultFilterMethod={(filter, row) => (filter.value === 'all') ? true : includes(row[filter.id], filter.value)}
    />
  )
}

export default VcenterAssetReportVcenters
